module.exports = __webpack_public_path__ + "img/3_113.f4d81eff.png";